/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { VisibilityOff, Visibility } from '@mui/icons-material';
import { FormControl, Input, InputAdornment, IconButton, MenuItem, TextField, Checkbox, Button, Box } from '@mui/material';
import { ReactComponent as UsernameIcon } from '../../assets/SVG/user.svg';
import { ReactComponent as PasswordIcon } from '../../assets/SVG/lock.svg';
import { ReactComponent as HospitalIcon } from '../../assets/SVG/hospital.svg';
import styles from './LoginFormComponent.module.css';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { loginDetails } from '../../types';
import { loginUser } from '../../services/apiService';
import axios from 'axios';
import { useAlert } from '../alertProvider';
import { useLoader } from '../loaderProvider/loader';
import { getLoginRedirect } from '../../utils/permissionService';
import i18n from '../../services/i18n';

interface Props {
    successroute: string;
    
}

const LoginFormComponent: React.FC<Props> = () => {
  const { t: tLogin } = useTranslation('login');

  
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const {showLoader, hideLoader} = useLoader();
  const location = useLocation();
  const {addAlert} = useAlert();
  const [error, setError] = useState({ username: false, password: false });

  const [showPassword, setShowPassword] = React.useState(false);
  const navigate = useNavigate();

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  const handleMouseUpPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  

  const Login = async () => {
    if (username.trim() === '' || password.trim() === '') {
      setError({
        username: username.trim() === '',
        password: password.trim() === '',
      });
      addAlert(tLogin('errors.empty'), 'error');
      return;
    }
    showLoader();
    
    const data:loginDetails={username,password};

       
    loginUser(data).then((res:any)=>{
      addAlert(tLogin('success'), 'success', { isLoginSuccess: true });
      localStorage.setItem('token',res?.access);
      localStorage.setItem('username',res?.username);
      localStorage.setItem('designation',res?.designation);
      localStorage.setItem('dj_admin_panel', (res?.is_staff || res?.is_superuser));
      
      localStorage.setItem('permissions',res?.permissions);

      // TODO: TEMPORARY - Set UAE dispense flow test flag. Remove after testing.
      // 'true' = UAE flow (shows dispensed pharmacy invoices)
      // 'false' = India flow (shows prescribed items for billing)
      localStorage.setItem('TEMP_TEST_UAE_DISPENSE_FLOW', 'true');

      const { module, route } = getLoginRedirect(res?.permissions); // Pass permissions to getLoginRedirect

      console.log('Login redirect:', { module, route }); // Log added for debugging

      console.log('location.state?.from:', location.state?.from); // Log added for debugging
      // Persist backend-provided default language_code for reference
      if (res?.language_code && localStorage.getItem('language_code') !== localStorage.getItem('language')) {
        localStorage.setItem('language_code', res.language_code);
      }
      const supportedLangs = ['en', 'es', 'hi', 'pt'];
      const selectedLang = localStorage.getItem('selected_language');
      const userSelectedLang = selectedLang && supportedLangs.includes(selectedLang) ? selectedLang : undefined;
      const backendLang = res?.language_code && supportedLangs.includes(res.language_code) ? res.language_code : undefined;
      const finalLang = userSelectedLang || backendLang || 'en';
      localStorage.setItem('language', finalLang);
      i18n.changeLanguage(finalLang);
      localStorage.removeItem('selected_language');


      if (location.state?.from && location.state?.from !== '/login') {
        navigate(location.state?.from);
      } else {
        if (module && route) {
          navigate(`/${route}`); // Navigate based on route priority
        } else {
          navigate('/admin/appointments'); // Fallback route
        }
      }
      
    }).catch ((error) => {
      if (axios.isAxiosError(error)) {
        let data;
        if (error.status === 401) {
          data = tLogin('errors.invalid');
        } else {
          data = error.message;
        }
        addAlert(data, 'error');
      } else {
        addAlert(tLogin('errors.failed'), 'error');
      }
      // Handle login failure (e.g., show an error message to the user) 
    }).finally (() => {
      hideLoader();
    }
    );
  };

  const handleSubmit = (event: any) => {
    event.preventDefault();

    // Check if username or password is empty
    if (username.trim() === '' || password.trim() === '') {
      setError({
        username: username.trim() === '',
        password: password.trim() === '',
      });
    }
  };
  const handleForgotPassword = () => {
    navigate('/forgot-password');
  };

  return (
    <div className={styles.form}>
      {/* <div className={styles.headings}>
        <h1>{tLogin('title')}</h1>
        <span>{tLogin('subtitle')}</span>
      </div> */}
      <div className={styles.fields} style={{ marginTop: '70px' }}>
        <Box className={styles.form} component="form" onSubmit={handleSubmit} noValidate>
          <FormControl sx={{ m: 1 }} variant="standard" style={{ width: '100%', marginTop: '16px' }}>
            <Input
              required
              id="standard-adornment-username"
              type='text'
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              startAdornment={
                <InputAdornment position="start">
                  <UsernameIcon style={{ marginBottom: '12px', marginRight: '8px' }} />
                </InputAdornment>
              }
              inputProps={{
                style: { height: '50px', padding: '0 0 10px 0', lineHeight: '50px', fontSize: '1.4rem'},
                placeholder: tLogin('username') || undefined
              }}
              style={{ height: '50px', width: '100%' }}
              error={error.username}
              
            />
          </FormControl>
          <FormControl sx={{ m: 1 }} variant="standard" style={{ width: '100%', margin: '0' }}>
            <Input
              required
              id="standard-adornment-password"
              type={showPassword ? 'text' : 'password'}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              startAdornment={
                <InputAdornment position="start">
                  <PasswordIcon style={{ marginBottom: '12px', marginRight: '8px' }} />
                </InputAdornment>
              }
              inputProps={{
                style: { height: '50px', padding: '0 0 10px 0', lineHeight: '50px' , fontSize: '1.4rem'},
                placeholder: tLogin('password')
              }}
              style={{ height: '50px' }}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    onMouseUp={handleMouseUpPassword}
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              }
              error={error.password}
            />
          </FormControl>
          <div className={styles.action}>
            <Button type="submit" className={styles.login} variant="contained" fullWidth onClick={() => Login()}>{tLogin('login')}</Button>
            <Button  className={styles.password_fg} variant="text" fullWidth     onClick={handleForgotPassword}>{tLogin('forgotPassword')}</Button>
          </div>
        </Box>
      </div>
      
    </div>
  );
};

export default LoginFormComponent;